export const image_root = `https://img.trex-arms.com/`

const kydex_color_swatch_path = `${ image_root }kydex_color_swatches/`
export const get_kydex_color_swatch_url = ({
	color_file_name,
	image_max_size,
	dpr,
}: {
	color_file_name: string
	image_max_size: number
	dpr: number
}) => `${ kydex_color_swatch_path }KydexColor_${ color_file_name }.png?auto=format&w=${ image_max_size }&dpr=${ dpr }&fit=crop&crop=focalpoint&fp-y=0.5&fp-x=0.5&fp-z=1.5`

export const background_texture_pathname = `${ image_root }holster_configurator/sidecar_background_head_on_2021-08-02.jpg`
